import { SvgProps } from '../../../../types/general'

const Play = ({ className }: SvgProps) => {
  return (
    <div className={className}>
      <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_24869_149)">
          <circle cx="36" cy="36" r="36" fill="white" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M52.2002 35.8704C52.2002 36.5135 51.8571 37.1077 51.3002 37.4292L29.7002 49.9C29.1433 50.2215 28.4571 50.2215 27.9002 49.9C27.3433 49.5784 27.0002 48.9842 27.0002 48.3411L27.0002 23.3996C27.0002 22.7565 27.3433 22.1623 27.9002 21.8408C28.4571 21.5192 29.1433 21.5192 29.7002 21.8408L51.3002 34.3115C51.8571 34.6331 52.2002 35.2273 52.2002 35.8704ZM30.6002 26.5173L30.6002 45.2234L46.8002 35.8704L30.6002 26.5173Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_24869_149">
            <rect width="72" height="72" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

export default Play
